import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { appTheme } from './core/theme/app-theme';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

import { es } from 'primelocale/es.json'


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withXhr(), 
      withInterceptors([AuthInterceptor])
    ),
    providePrimeNG({
      translation: es,
      theme: appTheme
    })
  ]
};
